import { Component, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";

interface FaqItem {
  id: number;
  question: string;
  answer: string;
  isOpen: boolean;
}

@Component({
  selector: "loyaltic-faq",
  templateUrl: "./faq.component.html",
  styleUrls: ["./faq.component.scss"],
})
export class FaqComponent implements OnInit, OnDestroy {
  faqItems: FaqItem[] = [];
  private faqTranslationSubscription: Subscription;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    const keys = this.getFaqTranslationKeys();
    this.faqTranslationSubscription = this.translate.stream(keys).subscribe((translations: any) => {
      this.loadFaqItems(translations);
    });
  }

  ngOnDestroy() {
    if (this.faqTranslationSubscription) {
      this.faqTranslationSubscription.unsubscribe();
    }
  }

  loadFaqItems(translations: any) {
    this.faqItems = Array.from({ length: 20 }, (_, index) => {
      const id = index + 1;
      const questionKey = `faq-question-${id}`;
      const answerKey = `faq-answer-${id}`;
      const question = this.translationOrEmpty(translations, questionKey);
      const answer = this.translationOrEmpty(translations, answerKey);

      if (!question || !answer) {
        return null;
      }

      return {
        id,
        question,
        answer,
        isOpen: false
      };
    }).filter((item: FaqItem | null): item is FaqItem => !!item);
  }

  toggleItem(item: FaqItem) {
    item.isOpen = !item.isOpen;
  }

  trackById(index: number, item: FaqItem) {
    return item.id;
  }

  private getFaqTranslationKeys() {
    const keys = ["faq-title", "faq-intro"];
    for (let id = 1; id <= 20; id++) {
      keys.push(`faq-question-${id}`);
      keys.push(`faq-answer-${id}`);
    }
    return keys;
  }

  private translationOrEmpty(translations: any, key: string) {
    const translated = translations && translations[key];
    return translated && translated !== key && translated.indexOf("✎") === -1 ? translated : "";
  }
}
